import React from "react";
import {updateQuestionInSurveyAtIdx} from "../../../../../slices/surveyEditorSlice";
import {decideBooleanString} from "../../../../../utils/SurveyUtils";
import {connect, useDispatch} from "react-redux";

function QuestionEditOptions(props) {

    const dispatch = useDispatch();

    const handleChangeOptionByName = (event, optionName) => {
        const {questionData, idx} = props;
        let newQuestionData = JSON.parse(JSON.stringify(questionData));

        newQuestionData.options[optionName] = decideBooleanString(newQuestionData.options[optionName]);

        // If option is randomized
        if (optionName.localeCompare("randomize") === 0) {
            // and randomized will be unchecked, exceptLast must be unchecked as well
            if (newQuestionData.options[optionName].localeCompare("false") === 0) {
                newQuestionData.options["exceptLast"] = "false";
            }
            // and randomized will be checked, reverse must be unchecked
            if (newQuestionData.options[optionName].localeCompare("true") === 0) {
                newQuestionData.options["reverse"] = "false";
            }
        }

        // If option is reverse
        if (optionName.localeCompare("reverse") === 0) {
            // and reverse will be checked, randomize and exceptLast must be unchecked
            if (newQuestionData.options[optionName].localeCompare("true") === 0) {
                newQuestionData.options["randomize"] = "false";
                newQuestionData.options["exceptLast"] = "false";
            }
        }

        dispatch(updateQuestionInSurveyAtIdx({idx: idx, questionData: newQuestionData}));
    };

    const disableExceptLast = typeof props.questionData.options === "undefined"
        || (typeof props.questionData.options.randomize === "undefined" || props.questionData.options.randomize.localeCompare("false") === 0);

    return (
        <React.Fragment>
            <div className="questionaire__builder__question__inputs__settings__title">SETTINGS</div>
            <div className="form__group">
                {/*form__group__check--disabled*/}
                {(props.questionData.type && ["singleChoice", "multipleChoice", "multipleOpen"].includes(props.questionData.type)) &&
                (
                    <label className="form__group__check" htmlFor={"reverse_option_" + props.questionData.id}>
                        <input className="form__group__check__input"
                               type="checkbox"
                               id={"reverse_option_" + props.questionData.id}
                               value={props.questionData.options.reverse}
                               onClick={(event) => {
                                   handleChangeOptionByName(event, "reverse")
                               }}
                               checked={props.questionData.options.reverse && props.questionData.options.reverse === "true"}
                        />
                        <span className="form__group__check__check"></span>
                        <span className="form__group__check__text">Randomly reverse scale</span>
                    </label>
                )
                }
                {(props.questionData.type && ["singleChoice", "multipleChoice", "multipleOpen", "selects"].includes(props.questionData.type)) &&
                (
                    <label className="form__group__check" htmlFor={"randomize_option_" + props.questionData.id}>
                        <input className="form__group__check__input"
                               type="checkbox"
                               id={"randomize_option_" + props.questionData.id}
                               value={props.questionData.options.randomize}
                               onClick={(event) => {
                                   handleChangeOptionByName(event, "randomize")
                               }}
                               checked={props.questionData.options.randomize && props.questionData.options.randomize === "true"}
                        />
                        <span className="form__group__check__check"></span>
                        <span className="form__group__check__text">{props.questionData.type.localeCompare("selects") === 0 ? "Randomize rows" : "Randomize answers"}</span>
                    </label>
                )
                }
                {(props.questionData.type && ["singleChoice", "multipleChoice", "multipleOpen", "selects"].includes(props.questionData.type)) &&
                (
                    <label className={"form__group__check " + (disableExceptLast ? "form__group__check--disabled" : "")} htmlFor={"exceptLast_option_" + props.questionData.id}>
                        <input className="form__group__check__input"
                               type="checkbox"
                               id={"exceptLast_option_" + props.questionData.id}
                               value={props.questionData.options.exceptLast}
                               onClick={(event) => {
                                   handleChangeOptionByName(event, "exceptLast")
                               }}
                               checked={props.questionData.options.exceptLast && props.questionData.options.exceptLast === "true"}
                               disabled={disableExceptLast}
                        />
                        <span className="form__group__check__check"></span>
                        <span className="form__group__check__text">Except last</span>
                    </label>
                )
                }
                {(props.questionData.type && ["singleChoice", "multipleChoice", "multipleOpen", "text", "number", "rating"].includes(props.questionData.type)) &&
                (
                    <label className="form__group__check" htmlFor={"noDKNA_option_" + props.questionData.id}>
                        <input className="form__group__check__input"
                               type="checkbox"
                               id={"noDKNA_option_" + props.questionData.id}
                               value={props.questionData.options.noDKNA}
                               onClick={(event) => {
                                   handleChangeOptionByName(event, "noDKNA")
                               }}
                               checked={props.questionData.options.noDKNA && props.questionData.options.noDKNA === "false"}
                        />
                        <span className="form__group__check__check"></span>
                        <span className="form__group__check__text">Add "Don’t know/ No Answer" answer</span>
                    </label>
                )
                }
            </div>
        </React.Fragment>
    );
}

export default connect()(QuestionEditOptions);